
import { Typography } from '@mui/material';
import React from 'react';
import { buildSearchCondition } from '../../search/SearchUtils';
import SearchableFilter from './SearchableFilter';

const SchedulerFilter = (props) => {
  const buildSearchConditions = (searchInput) => ([
    buildSearchCondition('name', 'contains', searchInput || '')
  ]);

  const renderOption = (option) => (
    <Typography noWrap>{option.name}</Typography>
  );
  return (
    <SearchableFilter
      entityType="Scheduler"
      label="Scheduler"
      searchKey="id"
      buildSearchConditions={buildSearchConditions}
      renderOption={renderOption}
      {...props}
    />
  );
};

export default SchedulerFilter;
